import Image from "next/image";
import style from "./style.module.scss";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "@/constants";
import Markets from "@/components/markets";
import { CONTENT } from "@/content";

const GetApp = () => {

  return (
    <div className={style.getAppContainer}>
      <div className={style.getAppCard}>
        <h3>{CONTENT.GET_APP.TITLE}</h3>
        <p>{CONTENT.GET_APP.DESCRIPTION}</p>
        <Markets height={40} />
      </div>
    </div>
  );
};

export default GetApp;

